import { axiosInstance } from ".";

export const getOrderStats = async (token) => {
  try {
    const result = await axiosInstance.get("admin/order/count");
    return result.data.data;
  } catch (error) {
    return error.response.data;
  }
};
export const getAllOrders = async (token) => {
  try {
    const result = await axiosInstance.get("admin/all/orders");
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};

export const getPage = async (token, url) => {
  try {
    const result = await axiosInstance.get(`${url}`);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
export const getLatestOrders = async (token) => {
  try {
    const result = await axiosInstance.get("admin/new/orders");
    return result.data.data;
  } catch (error) {
    return error.response.data;
  }
};
export const getOneOrder = async (token, saleId) => {
  try {
    const result = await axiosInstance.get(`admin/order/info/${saleId}`);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};

export const getPendingOrders = async (token) => {
  const result = await axiosInstance.get("admin/pending/orders");
  return result.data;
};

export const getFlaggedOrders = async (token) => {
  const result = await axiosInstance.get("admin/flagged/orders");
  return result.data;
};

export const getNewOrders = async (token) => {
  const result = await axiosInstance.get("admin/new/orders");
  return result.data;
};

export const getSellerPendingOrders = async (token, sellerId) => {
  try {
    const result = await axiosInstance.get(`admin/pending/order/${sellerId}`);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};

export const getApprovedOrders = async (token) => {
  const result = await axiosInstance.get("admin/approved/order");
  return result.data;
};

export const getCanceledOrders = async (token) => {
  const result = await axiosInstance.get("admin/canceled/order");
  return result.data;
};

export const markOrderSent = async (token, value) => {
  const result = await axiosInstance.post("admin/mark/order/sent", value);
  return result.data;
};

export const declineOrder = async (token, values) => {
  try {
    const result = await axiosInstance.post("admin/mark/order/rejected", values);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
